export default __webpack_public_path__ + "5d3c935.png";